import { Dropdown } from "antd"
import PropTypes from "prop-types"
import MoreActionEllipsis from "ui/MoreActionEllipsis"
import { Text } from "ui/Typography"
import TimeOffNotFound from "../TimeOffNotFound"
import { getTimeOffColumns, TIME_OFF_BE_KEYS } from "pagesV2/pro/Calendar/constants"
import styles from "../index.module.css"
import { useDevice } from "hooks/useDevice"

const TimeOffWeekdays = ({ timeOff, getDropdownItems }) => {
  const columns = getTimeOffColumns(TIME_OFF_BE_KEYS.weekDays)
  const { isMobile } = useDevice()
  if (!timeOff?.length) {
    return <TimeOffNotFound type="day(s) of the week" colSpan={columns.length} />
  }

  return (
    <tbody>
      {timeOff?.map((item) => {
        const { id, unavailable_weekday, start_time, end_time, all_day, start_date, end_date, recurring_yearly } = item || {}
        let time = `${start_time} - ${end_time}`
        if ((!start_time || !end_time) && all_day) {
          time = "Full day"
        }
        return (
          <tr key={id}>
            <td data-label={columns[0]}>
              <Text>{unavailable_weekday}</Text>
            </td>
            <td data-label={columns[1]}>
              <Text>{time}</Text>
            </td>
            <td data-label={columns[2]}>
              <Text>{start_date}</Text>
            </td>
            <td data-label={columns[3]}>
              <Text>{end_date ?? "-"}</Text>
            </td>
            <td data-label={columns[4]}>
              <Text>{recurring_yearly ? "Yes" : "No"}</Text>
            </td>
            <td data-label={columns[5]} className={styles.actionColumn}>
              <Dropdown trigger={["click"]} placement="bottomRight" menu={{ items: getDropdownItems(item) }}>
                {isMobile ? <Text className={styles.moreText}> More actions</Text> : <MoreActionEllipsis />}
              </Dropdown>
            </td>
          </tr>
        )
      })}
    </tbody>
  )
}

TimeOffWeekdays.propTypes = {
  timeOff: PropTypes.array,
  getDropdownItems: PropTypes.func
}

export default TimeOffWeekdays
